export function sliceToEven(stream, maxLength = 6) {
    return sliceToDivisible(stream, 2, maxLength);
}
export function sliceToDivisible(stream, divideBy, maxLength) {
    if (stream.length < divideBy) {
        return stream;
    }
    const length = Math.floor(Math.min(maxLength, stream.length) / divideBy) * divideBy;
    return stream.slice(0, length);
}
